import { render, staticRenderFns } from "./my-spin.vue?vue&type=template&id=9267689e&scoped=true"
import script from "./my-spin.vue?vue&type=script&lang=js"
export * from "./my-spin.vue?vue&type=script&lang=js"
import style0 from "./my-spin.vue?vue&type=style&index=0&id=9267689e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9267689e",
  null
  
)

export default component.exports